import React, {Component} from "react";
import { observer } from "mobx-react";
import { reaction, observable } from "mobx";
import { createSelectOptions } from "../../../utils/formatar";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import SelectWrapper from "../../comum/components/SelectWrapper";
import { statusLotePagamentoEnum } from "../../../utils/enums";
import { Validacao } from "../../comum/components/Validacao";
import TabelaFiltro from "../../comum/components/TabelaFiltro";
import PropTypes from "prop-types";

@observer
export class LotesPagamentoFiltro extends Component {
    static propTypes = {
        controller: PropTypes.object,
        filtrarStatus: PropTypes.bool,
        loginStore: PropTypes.object,
        onExportExcel: PropTypes.func
    };
    
    constructor(props) {
        super(props);
    }

    render() {
        const filtros = this.props.controller.filtros;
        const statusOptions = createSelectOptions(statusLotePagamentoEnum, "id", "valor");
        const loadingEmpresasGlobo = this.props.controller.loadingEmpresasGlobo;
        const empresaGloboOptions = createSelectOptions(this.props.controller.empresasGlobo, "id", "nome");
        const loadingETT = this.props.controller.loadingEtts;
        const ettOptions = createSelectOptions(this.props.controller.etts, "id", "nomeFantasia");
        return (
            <TabelaFiltro 
                carregarTabela={() => this.props.controller.aplicarFiltros()} 
                carregarDadosDaUrl={(params) => this.props.controller.carregarDadosDaUrl(params)} 
                filterValues={this.props.controller.filtros}
                onExportExcel={this.props.onExportExcel}
            >
                <div>
                    <Row>
                        <Col xs={12} md={12} lg={4}>
                            <FormGroup>
                                <Label>Unidade de negócio (BU)</Label>
                                <SelectWrapper 
                                    value={filtros.empresaGloboIds}
                                    multi={true}
                                    onChange={(value, option) => this.props.controller.setEmpresaGlobo(value, option)}
                                    noResultsText="Nenhum resultado encontrado"
                                    placeholder="Selecione..."
                                    isLoading={loadingEmpresasGlobo}
                                    options={empresaGloboOptions}/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={2}>
                            <FormGroup>
                                <Label for="cargo">Data geração (de)</Label>
                                <DatePicker
                                    ref="dataInicio"
                                    onClickOutside={()=>{this.refs.dataInicio.cancelFocusInput(); this.refs.dataInicio.setOpen(false);}}
                                    locale={"pt_BR"}
                                    className="form-control"
                                    dateFormat="DD/MM/YYYY"
                                    selectsEnd
                                    selected={this.props.controller.momentDataInicioFiltro}
                                    startDate={this.props.controller.momentDataInicioFiltro}
                                    endDate={this.props.controller.momentDataFimFiltro}
                                    onChange={(value) => this.props.controller.setMomentDataInicioFiltro(value)}
                                    onChangeRaw={(e) => this.props.controller.setDataInicioCheck(e.target.value)}/>
                                <Validacao id="dataInicio" valor={this.props.controller.dataInicioFiltroValidacao}
                                    tipo={["isDate"]}/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={2}>
                            <FormGroup>
                                <Label for="motivo">Data geração (até)</Label>
                                <DatePicker
                                    ref="dataFim"
                                    onClickOutside={()=>{this.refs.dataFim.cancelFocusInput(); this.refs.dataFim.setOpen(false);}}
                                    locale={"pt_BR"}
                                    className="form-control"
                                    dateFormat="DD/MM/YYYY"
                                    selectsEnd
                                    selected={this.props.controller.momentDataFimFiltro}
                                    startDate={this.props.controller.momentDataInicioFiltro}
                                    endDate={this.props.controller.momentDataFimFiltro}
                                    onChange={(value) => this.props.controller.setMomentDataFimFiltro(value)}
                                    onChangeRaw={(e) => this.props.controller.setDataFimCheck(e.target.value)}
                                />
                                <Validacao id="dataFim" valor={this.props.controller.dataFimFiltroValidacao}
                                    tipo={["isDate"]}/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={12} lg={4}>
                            <FormGroup>
                                <Label for="produto">Status</Label>
                                <SelectWrapper 
                                    value={filtros.status}
                                    multi={true}
                                    removeSelected={false}
                                    options={statusOptions}
                                    onChange={(value, options) => this.props.controller.setStatus(value, options)}
                                    noResultsText="Nenhum resultado encontrado" 
                                    placeholder="Selecione..." />
                            </FormGroup>
                        </Col>
                    </Row>
                    {this.props.loginStore.isPerfilAdministradorLogado  ? (
                        <Row>
                            <Col xs={12} md={6} lg={4}>
                                <FormGroup>
                                    <Label for="dataInicial">ETT</Label>
                                    <SelectWrapper 
                                        value={filtros.ettIds}
                                        multi={true}
                                        isLoading={loadingETT}
                                        onChange={(value, option) => this.props.controller.setETT(value, option)}
                                        noResultsText="Nenhum resultado encontrado"
                                        placeholder="Selecione..."
                                        options={ettOptions}/>
                                </FormGroup>
                            </Col>
                        </Row>
                    ) : ""}

                </div>
            </TabelaFiltro>
        );
    }
}